import http from '../services/http';

/**
 * 活动

 */
export default class insuranceService {
  constructor($http) {
    this.$http = $http;
  }

  /**
   * 获取活动
   */
  getActivityDetali(activitySuffix, provinceCode, phone) {
    const param = {
      url_suffix: activitySuffix,
    };
    if (parseInt(provinceCode)) {
      param.province_code = parseInt(provinceCode);
    }
    if (phone) {
      param.mobile_phone = phone;
    }
    return http.post('h5/activity_query', param);
  }
  // 领取优惠券
  userCouponReceive(code, phone) {
    return http.post('h5/activity_coupon_receive', {
      code,
      mobile_phone: phone,
    });
  }
  sendPhoneCode(phone) {
    return http.post('h5/sys_verify_code_get', { mobile_phone: phone });
  }
  registerUser(phone, code) {
    return http.post('h5/user_account_add', {
      mobile_phone: phone,
      verify_code: code,
    });
  }
}
